module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/landing-page/landing-page.component.css
// module id = ./src/app/components/landing-page/landing-page.component.css
// module chunks = main